import { render, staticRenderFns } from "./SelectableColorPicker.vue?vue&type=template&id=00162568&"
import script from "./SelectableColorPicker.vue?vue&type=script&lang=js&"
export * from "./SelectableColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports